"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectPartyToSendDelegate = void 0;
var vue_1 = require("vue");
var Button_1 = require("../components/common/Button");
var Party_1 = require("../components/Party");
var TranslateMixin_1 = require("./TranslateMixin");
exports.SelectPartyToSendDelegate = vue_1.default.component('select-party-to-send-delegate', {
    props: {
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data: function () {
        return {
            selectedParty: undefined,
        };
    },
    components: { Button: Button_1.Button, Party: Party_1.Party },
    mixins: [TranslateMixin_1.TranslateMixin],
    methods: {
        saveData: function () {
            var result = [];
            result.push([]);
            if (this.selectedParty !== undefined) {
                result[0].push(this.selectedParty);
            }
            this.onsave(result);
        },
        isDominant: function (partyName) {
            var _a;
            return partyName === ((_a = this.playerinput.turmoil) === null || _a === void 0 ? void 0 : _a.dominant);
        },
        partyAvailableToSelect: function (partyName) {
            if (this.playerinput.availableParties === undefined) {
                return false;
            }
            else {
                return this.playerinput.availableParties.includes(partyName);
            }
        },
    },
    template: "\n    <div class=\"wf-component wf-component--select-party\">\n        <div v-if=\"showtitle === true\" class=\"nofloat wf-component-title\">{{ $t(playerinput.title) }}</div>\n        <div class=\"wf-component--list-party\">\n          <label v-for=\"party in playerinput.turmoil.parties\" :key=\"party.name\">\n              <input type=\"radio\" v-model=\"selectedParty\" :value=\"party.name\" v-if=\"partyAvailableToSelect(party.name)\"/>\n              <party :party=\"party\" :isDominant=\"isDominant(party.name)\" :isAvailable=\"partyAvailableToSelect(party.name)\"/>\n          </label>\n        </div>\n        <div v-if=\"showsave === true\" class=\"nofloat\">\n            <Button :onClick=\"saveData\" :title=\"playerinput.buttonLabel\" /> \n        </div>\n    </div>\n    ",
});
//# sourceMappingURL=SelectPartyToSendDelegate.js.map